import { footCerts, footColumns } from "@/mocks/homeData";

export default function CtaFooter() {
  return (
    <>
      <section className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="relative overflow-hidden rounded-lg bg-accent-500 px-6 py-10 md:px-10 md:py-14">
          <i className="ri-search-eye-line absolute -right-6 -top-6 text-[9rem] text-accent-600/40 md:text-[12rem]" />
          <div className="relative max-w-2xl">
            <p className="text-xs font-medium uppercase tracking-widest text-accent-900">下个热曝来之前</p>
            <h2 className="mt-2 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              与其被动刷到被牵着走，
              <br className="hidden md:block" />
              不如把来龙去脉先看明白
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-accent-900">
              收藏本站作为「追热曝」的第一站——从当事人是谁、身份起底、背景深扒，到关联人物与旧料翻出，一处查全。
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <a
                href="#archives"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 whitespace-nowrap"
              >
                浏览事件档案
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#rank"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-background-50/80 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-background-50 whitespace-nowrap"
              >
                <i className="ri-fire-line text-primary-600" />
                先看今日热榜
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-primary-800 text-background-100">
        <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6">
          <div className="grid gap-10 lg:grid-cols-12">
            <div className="lg:col-span-4">
              <a href="#top" className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-lg text-primary-700">
                  <i className="ri-spy-line" />
                </span>
                <span className="font-heading text-xl font-bold text-background-50">
                  网曝<span className="text-accent-300">·</span>速查
                </span>
              </a>
              <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
                面向关注热点人物与事件来龙去脉的读者，梳理当事人是谁、身份起底、背景深扒、关联人物、社交账号查找与旧料翻出等公开信息线索。
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {footCerts.map((c) => (
                  <span
                    key={c}
                    className="inline-flex items-center gap-1 rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100/90 ring-1 ring-background-50/15"
                  >
                    <i className="ri-shield-check-line text-accent-300" />
                    {c}
                  </span>
                ))}
              </div>
            </div>

            {footColumns.map((col) => (
              <div key={col.title} className="lg:col-span-2 lg:col-start-auto">
                <h3 className="font-heading text-sm font-bold text-background-50">{col.title}</h3>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#top"
                        className="text-sm text-background-100/75 transition-colors hover:text-accent-300"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="lg:col-span-2">
              <h3 className="font-heading text-sm font-bold text-background-50">保持同步</h3>
              <p className="mt-4 text-sm leading-relaxed text-background-100/75">
                关注本站热榜更新，不错过每一个仍在发酵的重要进展。
              </p>
              <div className="mt-4 flex items-center gap-2">
                <a
                  href="#top"
                  aria-label="微信公众号"
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-100 ring-1 ring-background-50/15 transition-colors hover:bg-background-50/20"
                >
                  <i className="ri-wechat-line" />
                </a>
                <a
                  href="#top"
                  aria-label="微博"
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-100 ring-1 ring-background-50/15 transition-colors hover:bg-background-50/20"
                >
                  <i className="ri-weibo-line" />
                </a>
                <a
                  href="#top"
                  aria-label="RSS"
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-100 ring-1 ring-background-50/15 transition-colors hover:bg-background-50/20"
                >
                  <i className="ri-rss-line" />
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row">
            <p className="text-xs text-background-100/60">
              © {new Date().getFullYear()} 网曝速查 · 仅整理公开可见信息，仅供信息梳理参考
            </p>
            <p className="text-xs text-background-100/60">
              事实有别于推断 · 请以权威渠道核实为准
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}